import Seo from "@/components/Seo";
import Hero from "@/components/sections/Hero";
import ServicesBento from "@/components/sections/ServicesBento";
import TechSection from "@/components/sections/TechSection";
import ProcessSection from "@/components/sections/ProcessSection";
import EditorialMarquee from "@/components/Marquee";
import WhySection from "@/components/sections/WhySection";
import CommercialPartner from "@/components/sections/CommercialPartner";
import PreventiveSection from "@/components/sections/PreventiveSection";
import FurnaceSentinelDemo from "@/components/sections/FurnaceSentinelDemo";
import Gallery from "@/components/sections/Gallery";
import Testimonials from "@/components/sections/Testimonials";
import ServiceArea from "@/components/sections/ServiceArea";
import EmergencySection from "@/components/sections/EmergencySection";
import LeadSection from "@/components/sections/LeadSection";
import CTASection from "@/components/sections/CTASection";

export default function Home() {
  return (
    <>
      <Seo
        title="Genuine Forge — Engineering-Driven HVAC Contractor | Chicago"
        description="Precision HVAC service, diagnostics, replacement, and installation for residential and light commercial systems across Chicago. Built right. Diagnosed precisely."
      />
      <Hero />
      <ServicesBento />
      <TechSection />
      <ProcessSection />
      <EditorialMarquee />
      <WhySection />
      <CommercialPartner />
      <PreventiveSection />
      <FurnaceSentinelDemo />
      <Gallery />
      <Testimonials />
      <ServiceArea />
      <EmergencySection />
      <LeadSection />
      <CTASection />
    </>
  );
}
